import React from 'react';
import type { ChessMove } from '../../../types/chess';

interface ChessHistoryProps {
  moves: ChessMove[];
}

export function ChessHistory({ moves }: ChessHistoryProps) {
  const formatPosition = (pos: { row: number; col: number }) => {
    const files = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'];
    const ranks = ['8', '7', '6', '5', '4', '3', '2', '1'];
    return `${files[pos.col]}${ranks[pos.row]}`;
  };

  return (
    <div className="bg-gray-800 p-4 rounded-lg">
      <h3 className="text-lg font-bold text-white mb-4">Move History</h3>
      
      <div className="space-y-2 max-h-[300px] overflow-y-auto">
        {moves.map((move, index) => (
          <div key={index} className="flex items-center gap-2 text-sm">
            <span className="text-gray-400">{Math.floor(index/2 + 1)}.</span>
            <span className={index % 2 === 0 ? 'text-cyan-400' : 'text-pink-500'}>
              {formatPosition(move.from)}-{formatPosition(move.to)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}